import { ADD_CAR_ADDRESS_INPUT_CHANGE, SET_CN_LOCATION_LIST } from '../../types';

const initialState = {
  streetName: '',
  cityName: '',
  stateRegion: '',
  zipCode: '',
  countryName: '',
  phoneNumber: '',
  firstName: '',
  lastName: '',
  companyName: '',
  companyVatId: '',
  identificationNumber: '',
  registrationType: 'personal',
  identificationType: 'identification',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD_CAR_ADDRESS_INPUT_CHANGE:
      return {
        ...state,
        ...action.payload,
      };
    case SET_CN_LOCATION_LIST:
      return {
        ...state,
        locations: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
